import { useDispatch } from "react-redux";
import { clearStorageForNewAppraisal } from "../../sessionAndLocalStorage";
import { appraisalSlice } from "../../store/slices/Appraisal";
import { useRetryRequest } from "../../hooks/useRetryRequest";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useReuseAppraisals from "../../hooks/useReuseAppraisals";
import { useSelector } from "react-redux";
import { getAppraisalData } from "../../store/selectors";

export const useReuseVehicle = (recalculateSavedDealAppraisal: boolean) => {
  const [useSameDetailsId, setUseSameDetailsId] = useState();
  const { vehicleAndQuestionsRequest } = useRetryRequest();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    islocalAppraisalDataValid = false,
    localAppraisalsData,
    isQuestionSetValid,
    readyToRender
  } = useReuseAppraisals();

  const {
    vehicle = {},
    appraisal = {},
    vehicle: localVehicle = {}
  } = localAppraisalsData;

  const loading = !readyToRender;
  let { mileage: localStorageMileage = "" } = localVehicle;
  const { model, derivative, registration } = vehicle;
  const location = window.location;
  const queryString = location.search;
  const urlParams = new URLSearchParams(queryString) || {};
  const idParam = urlParams.get("appraisalSessionId");
  const reuseAppraisal = urlParams.get("reuseAppraisal") === "true";
  const discardPreviousAppraisal = urlParams.get("reuseAppraisal") === "false";
  const { data = {} } = appraisal;
  const { questionsAndAnswers: localQuestionsAndAnswers = {} } = data;
  const { appraisalSessionId } = useSelector(getAppraisalData);

  const startNewValuation = () => {
    clearStorageForNewAppraisal();
    window.location.assign(`registration/${queryString}`);
  };

  useEffect(() => {
    if (registration && appraisalSessionId && !recalculateSavedDealAppraisal) {
      vehicleAndQuestionsRequest(registration);
    }
  }, [registration, appraisalSessionId]);

  const handleLanding = () => {
    if (recalculateSavedDealAppraisal) return;
    if (discardPreviousAppraisal) {
      startNewValuation();
    }
    if (readyToRender) {
      if (reuseAppraisal) {
        revisitAppraisals();
      }
      if (!islocalAppraisalDataValid || !isQuestionSetValid) {
        dispatch(appraisalSlice.actions.setIsReuseAppraisal(false));
        startNewValuation();
      }
    }
  };

  useEffect(handleLanding, [dispatch, location, readyToRender]);

  const revisitAppraisals = () => {
    if (idParam && localQuestionsAndAnswers && islocalAppraisalDataValid) {
      dispatch(appraisalSlice.actions.setIsReuseAppraisal(true));
      dispatch(appraisalSlice.actions.setAppraisalSessionId(idParam));
      dispatch(
        appraisalSlice.actions.setQuestionsAndAnswers(localQuestionsAndAnswers)
      );
    }
    if (islocalAppraisalDataValid && registration) {
      vehicleAndQuestionsRequest(registration);
    }

    navigate(
      `/mileage/${queryString}&registration=${registration}&revisitAppraisals=${true}`
    );
  };

  return {
    model,
    derivative,
    registration,
    startNewValuation,
    revisitAppraisals,
    localStorageMileage,
    localQuestionsAndAnswers,
    useSameDetailsId,
    setUseSameDetailsId,
    islocalAppraisalDataValid,
    loading
  };
};
